module.exports = __webpack_public_path__ + "resources/img/img-tmax-hyper-sql-for-postgre-sql-02-en.73a8539baa42182474e9cae141cabe2b.png";